<template>
  <istforminput
    data-test="ist-form-time"
    v-bind="$attrs"
    :stack-label="dense ? undefined : true"
    placeholder="hh:mm"
    :align="align"
    :ref="name"
    :disable="localdisable"
    :disabled="localdisable"
    v-model="localvalue"
    :dense="localdense"
    :error="error || localError"
    :autofocus="autofocus"
    @blur="onBlur"
    @focus="onFocus"
    @update:modelValue="onchange"
    @keyup="keyup"
    style="padding-bottom: 0"
    :class="{ dense: localdense }"
    mask="##:##"
    unmasked-value
    type="text"
  />
</template>

<script lang="ts">
import { Options, Emit, Prop, Watch, Vue } from "vue-property-decorator";
import { QInput } from "quasar";
import istforminput from "./IstFormInput.vue";
import { add, format, parse as fnsParse, isValid } from "date-fns";
import { nextTick, ref } from "vue";
import { formatTimeString, isTimeValid } from "@/utils/dateUtils";

@Options({
  components: {
    istforminput
  }
})
export default class App extends Vue {
  name = "IstFormInput";
  inputref = ref(null);
  localvalue = "";
  localdisable = false;
  localdense = false;
  localError = false;
  lGrey: boolean | string = false;
  timeRegex = /(0[0-9]|1[0-9]|2[0-3]|[0-9]):([0-5][0-9])/;

  @Prop({ default: null })
  validation!: any;
  @Prop({ default: "" })
  modelValue!: string;
  @Prop({ default: false, type: [Boolean, String] })
  disable!: boolean | string;
  @Prop({ default: "" })
  placeholder!: string;
  @Prop({ default: false, type: [Boolean, String] })
  focus!: boolean;
  @Prop({ default: "" })
  min!: string;
  @Prop({ default: "" })
  max!: string;
  @Prop({ default: "left" })
  align!: string;
  @Prop({ default: false, type: [Boolean, String] })
  error!: boolean | string;
  @Prop({ default: false, type: [Boolean, String] })
  dense!: boolean | string;
  @Prop({ default: false, type: [Boolean, String] })
  grey!: boolean | string;
  @Prop({ default: false, type: [Boolean] })
  autofocus!: boolean;

  created() {
    this.inputref = ref(null);
  }

  mounted() {
    this.localvalue = this.modelValue;
    this.localdisable =
      (typeof this.disable === "boolean" && this.disable) || this.disable == "true";
    this.localdense = (typeof this.dense === "boolean" && this.dense) || this.dense == "true";
    if (this.autofocus) {
      // Grunden til denne vederstyggelighed er, når man genåbner en dialog fungerer autofocus ikke korrekt.
      // Derfor har det været nødvendigt at benytte denne løsning.
      setTimeout(() => {
        if (this.inputref) {
          (this.inputref[0] as QInput).focus(), 100;
        }
      });
    }
  }

  @Watch("modelValue")
  onmodelValue(value) {
    this.localvalue = value;
  }

  @Watch("value")
  onvalue(value) {
    this.localvalue = value;
  }

  @Watch("disable")
  ondisable(value) {
    this.localdisable = value;
    if (value == false) {
      if (this.autofocus) {
        setTimeout(() => {
          if (this.inputref) {
            (this.inputref[0] as QInput).focus(), 100;
          }
        });
      }
    }
  }

  @Watch("dense")
  onDense(value) {
    this.localdense = value;
  }

  @Emit("blur")
  onBlur() {
    this.localvalue = formatTimeString(this.localvalue);
    if (!isTimeValid(this.localvalue)) {
      this.localError = true;
    } else {
      this.localError = false;
    }
    this.onchange(this.localvalue);
    return;
  }

  @Emit("focus")
  onFocus() {
    return;
  }

  @Emit("change")
  @Emit("input")
  @Emit("value")
  @Emit("update:modelValue")
  onchange(val) {
    this.$emit("change", this.localvalue);
    this.$emit("input", this.localvalue);
    this.$emit("update:modelValue", this.localvalue);
    return val;
  }

  onclick(event) {
    (event.target as HTMLInputElement).focus();
  }

  async keyup(event) {
    let AddValue = 0;
    // keyup
    if (event.keyCode == "38") {
      AddValue = 1;
    }
    // keydown
    if (event.keyCode == "40") {
      AddValue = -1;
    }

    // komponenten kvæler følgende events fra omgivelserne,
    // ved at blur elementet kan andre opfange dem,
    // f.eks. escape ifm. lukning af modal og enter ifm. submit
    // emitting kan være en mulighed hvis vi siger emit-escape altid er anuller og emit-enter altid er submit.
    if (event.key == "Escape" || event.key == "Enter") {
      (document as any).activeElement.blur();
      this.$emit("blur");
    }

    if (AddValue != 0) {
      const start = event.target.selectionStart;
      if (event) {
        event.stopPropagation();
        event.preventDefault();
        event.returnValue = false;
        event.cancelBubble = true;

        const [hrs, mins]: [number, number] = this.GetTimeValue();
        const fakeDate = new Date(2000, 1, 1, 0, 0);
        fakeDate.setHours(hrs, mins);
        let modifiedString;

        if (event.target.selectionStart > 2) {
          modifiedString = add(fakeDate, { minutes: AddValue });
        } else {
          modifiedString = add(fakeDate, { hours: AddValue });
        }
        if (this.localvalue != format(modifiedString, "HH:mm")) {
          this.localvalue = format(modifiedString, "HH:mm");
          this.onchange(this.localvalue);
        }
      }
      await nextTick();
      event.target.setSelectionRange(start, start);
      return false;
    }
    return false;
  }

  GetTimeValue(): [number, number] {
    if (this.localvalue.length == 1) {
      this.localvalue = "0" + this.localvalue;
    }
    let value = this.localvalue.replace(":", "") + "0000";
    value = value.substr(0, 2) + ":" + value.substr(2, 2);
    const res = value.match(this.timeRegex);
    if (res) {
      return [+res[1], +res[2]];
    }

    return [0, 0];
  }
}
</script>

<style scoped lang="scss">
.dense {
  padding: 0;

  border: 0px;
  font-size: small;
}
.dense :deep(.q-field__control) {
  padding: 0 !important;
  min-width: 43px;
}

.dense :deep(INPUT) {
  text-align: center;
}

.grey {
  border-radius: 4px;
  background-color: #eee;
}
</style>
